import { useFormikContext } from "formik";
import { useDispatch } from "react-redux";
import { getCodigoPostal } from "../../../../redux/actions/direccion";
import FormikTextField from "../FormikTextField";


const FormikNumero = ({ nameLocationFields, label }) => {
    const dispatch = useDispatch();

    const { values, setFieldValue } = useFormikContext();
    const handleGetCodigoPostal = () => {
        dispatch(
            getCodigoPostal(values[nameLocationFields.provincia],
                values[nameLocationFields.localidad],
                parseInt(values[nameLocationFields.numero]),
                values[nameLocationFields.calle]
            )
        ).then((res) => {
            if (res.value.data.codigoPostal) {
                setFieldValue("codigoPostal", res.value.data.codigoPostal);
            }
        });
    }
    return (
        <FormikTextField
            name={nameLocationFields.numero}
            label={label ? label : "Número"}
            fullWidth
            disabled={!values[nameLocationFields.calle]}
            onBlur={(value) => {
                if (value.target.value && !isNaN(value.target.value)) {
                    handleGetCodigoPostal();
                } else {
                    setFieldValue(nameLocationFields.codigoPostal, "");
                }
            }}
        />
    )
}

export default FormikNumero;